module.exports = __webpack_public_path__ + "media/images/common/select-arrow-22dc3b4dab906f07c07dfc5acdea2230.svg";